import { client } from './client';
import interceptors from './interceptors';

client.interceptors.request.use(interceptors.auth, interceptors.onError);

function getHistoryEwallet(params) {
	return client.get('tunnel/api/stockist/ewallet/history', {
		params: params
	});
}

function getBalanceEwallet() {
	return client.get('tunnel/api/stockist/ewallet/balance');
}

export default {
	getHistoryEwallet,
	getBalanceEwallet,
}